import { render, staticRenderFns } from "./share-event-modal.vue?vue&type=template&id=67b5d1d3&scoped=true"
import script from "./share-event-modal.vue?vue&type=script&lang=js"
export * from "./share-event-modal.vue?vue&type=script&lang=js"
import style0 from "./share-event-modal.vue?vue&type=style&index=0&id=67b5d1d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5d1d3",
  null
  
)

export default component.exports